<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">
            <el-form-item label="运营商名称："> 
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="getListPageHandle()" icon="el-icon-search">搜 索</el-button>
                <el-button type="success" @click="showEditVisibale(null)" icon="el-icon-edit">新 增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >  
            <el-table-column type="index" label="序号" width="50"></el-table-column> 
            <el-table-column prop="supplierName" label="运营商名称"></el-table-column>
            <el-table-column prop="cardState" label="可换卡状态">
                <template v-slot="scope">
                    {{formatCardState(scope.row.cardState)}}
                </template> 
            </el-table-column>
            <el-table-column  label="是否允许换卡">
                <template v-slot="scope">
                    {{scope.row.isChange==1? "允许": "禁止"}}
                </template> 
            </el-table-column>
            <el-table-column  label="是否需要有效套餐">
                <template v-slot="scope">
                    {{scope.row.isPkg==1? "需要": "不需要"}}
                </template>
            </el-table-column>
            <el-table-column prop="cardType" label="可换卡类型">
                <template v-slot="scope">
                    {{formatCardType(scope.row.cardType)}}
                </template>  
            </el-table-column>
            <el-table-column prop="remark" label="弹窗内容"></el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <el-button type="text" size="small" @click="showEditVisibale(scope.row)">编 辑</el-button>
                </template>    
            </el-table-column>
        </el-table>       
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  

        <el-dialog :append-to-body="true"  title="编辑" :visible.sync="editVisibale" width="600px"  class="notifyDetail" :close-on-click-modal="false" @close="cancel()">
            <el-form ref="editForm" :model="editForm"  label-width="140px">
                <el-form-item label="供应商名称："> 
                    <el-select v-model="editForm.supplierCode" clearable filterable placeholder="请选择">
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否允许换卡:">  
                    <el-radio v-model="editForm.isChange" label="1">允许</el-radio>
                    <el-radio v-model="editForm.isChange" label="0">禁止</el-radio>
                </el-form-item>

                <el-form-item label="允许换卡状态：">                     
                    <el-checkbox-group v-model="checkedState" >
                        <el-checkbox v-for="item in cardStateOption" :label="item.code" :key="item.id">{{item.description}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                
                <el-form-item label="是否需要有效套餐：">  
                    <el-radio v-model="editForm.isPkg" label="1">需要</el-radio>
                    <el-radio v-model="editForm.isPkg" label="0">不需要</el-radio>
                </el-form-item>

                

                <el-form-item label="弹窗内容：">  
                    <el-input v-model.trim="editForm.remark" clearable></el-input>
                </el-form-item>


                <el-form-item label="可换卡类型:">  
                    <el-radio v-model="editForm.cardType" label="2">联通卡</el-radio>
                    <el-radio v-model="editForm.cardType" label="1">电信卡</el-radio>
                    <el-radio v-model="editForm.cardType" label="0">移动卡</el-radio>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="confirmHandler()">确 定</el-button>
            </div>
        </el-dialog>       
    </div>
</template>
<script>
import {sysRequest} from '@/api/customizedRequest.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                supplierCode: null,
            },

            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },            

            editVisibale: false,

            branchSupplierOption: [],//供应商字典
            cardStateOption: [],//卡状态字典
            //已选的卡状态
            checkedState: [],

            actionType: 0,//0为新增， 1为编辑
            editForm: {
                remark:null,
                id:null,
                isChange:null,
                isPkg:null,
                cardState:null,
                supplierCode:null,
                supplierName:null,
                cardType:null,
            },

        }
    },
    methods: {
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            sysRequest("/sim/change/listPage", data, "post").then(res => {
                common.listCallback(this, res, 'tbpg'); 
            })
        },

        showEditVisibale(data){
            if(data){
                this.actionType = 1;
                for(let key in this.editForm){
                    this.editForm[key] = data[key];
                }
                this.editForm.isPkg = this.editForm.isPkg + "";
                this.editForm.isChange = this.editForm.isChange + "";
                this.editForm.cardType = this.editForm.cardType + "";
                this.editForm.remark = this.editForm.remark + "";
                this.checkedState = this.editForm.cardState.split(",").map(Number);
                this.editVisibale = true;
            }else{
                this.actionType = 0;
                this.editVisibale = true;
            }
            
        },

        cancel(){
            this.checkedState = [];
            for(let key in this.editForm){
                this.editForm[key] = null;
            }
            this.editForm.isPkg = null;
            this.editForm.isChange = null;
            this.editForm.cardType = null;
            this.editVisibale = false;
        },

        confirmHandler(){
            let d = this.editForm;
            for(let i=0; i<this.branchSupplierOption.length; i++){
                if(this.branchSupplierOption[i].id == d.supplierCode){
                    d.supplierName = this.branchSupplierOption[i].name + '(' + this.branchSupplierOption[i].alias + ')';
                    break;
                }
            }
            d.cardState = this.checkedState.join(",");

            //校验
            if(d.isChange==null|| d.isChange==""||
                d.isPkg==null|| d.isPkg==""||
                d.cardState==null|| d.cardState==""||
                d.supplierCode==null|| d.supplierCode==""||
                d.supplierName==null|| d.supplierName==""||
                d.cardType==null||d.cardType==""){
                this.$message.error('请将信息填写完整'); 
                return;
            }
            this.$confirm('确定要保存此配置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                
                let url = "";
                if(this.actionType == 1){
                    url = "sim/change/update";
                }else{
                    url = "sim/change/add";
                }

                sysRequest(url, d, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getListPageHandle();
                        this.cancel();
                    }else{
                       this.$message.error(res.data.message); 
                    }
                })
            }).catch(() => {
                this.cancel();
            })
        },
        formatCardType(type){
            if(type == 0){
                return '移动卡'
            }
            else if(type == 1){
                return '电信卡'
            }
            else if(type == 2){
                return '联通卡'
            }
        },

        formatCardState(cardState){
            let str = '';
            let array = cardState.split(",").map(Number);
            for(let j=0; j<array.length; j++){
                for(let i=0; i<this.cardStateOption.length; i++){
                    if(this.cardStateOption[i].code == array[j]){
                        str += this.cardStateOption[i].description+"，";
                        break;
                    }
                }
            }

            if(str.lastIndexOf('，') == str.length-1){
                return str.substring(0, str.length-1);
            }
            else{
                return str;
            }
            
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getListPageHandle();
        }  
    },
    created () {
        this.getListPageHandle();

        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
        sysRequest("sim/state/dict", {}, "get").then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
            }else{
                this.$message.error(res.data.message);
            }    
        });
    } 
}
</script>
<style lang="less" scoped>
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

